import React, { MouseEvent, SyntheticEvent } from 'react';
import { withPrefix } from 'gatsby-link';
import { Button, ButtonSizes, ButtonStyles, Text, Avatar } from '@quantum/ui-atoms';
import sanitizeHtml from 'xss';
import { IconsLgcLogo } from '@/icons';
import * as styles from './styles.module.scss';

export interface InterstitialProps {
  avatarUrl: string;
  jobTitle: string;
  personName: string;
  header: string;
  quote: string;
  ctaText: string;
  disclaimer?: string;
  onClick: (event: MouseEvent<HTMLAnchorElement> | SyntheticEvent<HTMLButtonElement>) => void;
}

export const Interstitial: React.FC<InterstitialProps> = ({
  avatarUrl,
  jobTitle,
  personName,
  ctaText,
  quote,
  header,
  disclaimer,
  onClick,
}) => (
  <div className={styles.root}>
    <IconsLgcLogo />
    <Text as='h2' className={styles.header}>
      {header}
    </Text>
    <div className={styles.divider} />
    <Text as='p' className={styles.quote}>
      {quote}
    </Text>
    <div className={styles.personInfo}>
      <Avatar className={styles.avatar} url={withPrefix(avatarUrl)} />
      <div className={styles.details}>
        <Text as='p' className={styles.name}>
          {personName}
        </Text>
        <Text as='p' className={styles.jobTitle}>
          {jobTitle}
        </Text>
      </div>
    </div>

    <div>
      <Button
        animate
        buttonStyle={ButtonStyles.primary}
        size={ButtonSizes.large}
        text={ctaText}
        fullWidth
        onClick={onClick}
      />
      {disclaimer && (
        <div className={styles.disclaimer} dangerouslySetInnerHTML={{ __html: sanitizeHtml(disclaimer) }} />
      )}
    </div>
  </div>
);
